import { z } from 'zod';

function withExistenceFiltered(schema) {
  return z.preprocess((val) => {
    const _val = Array.isArray(val) ? val : [val];
    return _val.filter((val2) => val2 !== void 0 && val2 !== null);
  }, schema);
}

export { withExistenceFiltered };
